import { render, staticRenderFns } from "./CurriculumReceiver.vue?vue&type=template&id=dcbf2dee&scoped=true&lang=pug"
import script from "./CurriculumReceiver.vue?vue&type=script&lang=js"
export * from "./CurriculumReceiver.vue?vue&type=script&lang=js"
import style0 from "./CurriculumReceiver.vue?vue&type=style&index=0&id=dcbf2dee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcbf2dee",
  null
  
)

export default component.exports